import cx from "classnames";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { NavLinkItemsQuery } from "../../graphql-types";
import InternalLink from "./InternalLink";

type Props = {
  absolutePath: string;
  hardcodedLinks?: {
    title: string;
    path: string;
  }[];
};

type LinkNodeType = { path: string; title: string };

const STATIC_QUERY = graphql`
  query NavLinkItems {
    home {
      path
      lexicon {
        home
      }
      navLinks {
        title
        path
      }
      signUp {
        path
        title
      }
    }
    allSustainabilityLandingPage {
      nodes {
        title
        path
      }
    }
  }
`;

const NavLinkItems = ({ hardcodedLinks = [], absolutePath }: Props) => {
  const { home, allSustainabilityLandingPage } =
    useStaticQuery<NavLinkItemsQuery>(STATIC_QUERY);
  if (!home) {
    throw new Error("Could not find home node");
  }

  const links = home.navLinks.concat(hardcodedLinks);

  const liLink =
    "block py-1 text-jumbo text-center text-2xl font-semibold lg:inline-block lg:text-sm";

  const isActive = (path: string) => absolutePath.includes(path);

  const linkNodes: LinkNodeType[] = [];
  let pushed = false;

  links.forEach((el, i) => {
    linkNodes.push(el);
    if (el.title === "Dirt is Good Project" && !pushed) {
      allSustainabilityLandingPage.nodes.forEach((susEl) => {
        linkNodes.push(susEl);
        pushed = true;
      });
    }
    if (
      links.length === i + 1 &&
      links.length === linkNodes.length &&
      allSustainabilityLandingPage.nodes.length
    ) {
      linkNodes.push(...allSustainabilityLandingPage.nodes);
    }
  });

  return (
    <>
      {linkNodes.map((link) => (
        <li
          key={link.path}
          className={cx("lg:ml-8 lg:items-center lg:flex", {
            active: isActive(link.path),
          })}
        >
          <span className="hover hover-1">
            <InternalLink className={liLink} href={link.path}>
              {link.title}
            </InternalLink>
          </span>
        </li>
      ))}
      {home.signUp && (
        <li
          className={cx("lg:ml-8 lg:items-center lg:flex", {
            active: isActive(home.signUp.path),
          })}
        >
          <span className="hover hover-1">
            <InternalLink className={liLink} href={home.signUp.path}>
              {home.signUp.title}
            </InternalLink>
          </span>
        </li>
      )}
    </>
  );
};

export default NavLinkItems;
